import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useLang } from "../../lib/i18n";

const SERIES = [
  ["rice_husk", "#E8B04B"],
  ["paddy_straw", "#7FB2FF"],
  ["wheat_bhusa", "#6EE7C5"],
  ["mustard_stalk", "#EEF3EA"],
];

export const RateChart = ({ history }) => {
  const { t, lang } = useLang();
  const names = t("supply.materials");
  const rows = Array.isArray(history) ? history : [];
  const data = rows.map((h) => ({
    label: new Date(h.week_start).toLocaleDateString(lang === "hi" ? "hi-IN" : "en-IN", { day: "numeric", month: "short" }),
    ...Object.fromEntries(SERIES.map(([k]) => [k, h?.rates?.[k] ?? null])),
  }));
  const active = SERIES.filter(([k]) => data.some((d) => d[k] != null));

  return (
    <div data-testid="rate-chart" className="mt-6 pt-5 border-t border-[#E8B04B]/20">
      <p className="eyebrow mb-3">{t("rates.trend")}</p>
      {data.length < 2 || !active.length ? (
        <p data-testid="rate-chart-empty" className="text-sm text-[var(--sage)]">{t("rates.trendEmpty")}</p>
      ) : (
        <div className="h-52 -ml-3">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
              <CartesianGrid stroke="rgba(110,231,197,0.08)" vertical={false} />
              <XAxis dataKey="label" tick={{ fill: "#A9C2B8", fontSize: 12 }} axisLine={false} tickLine={false} />
              <YAxis domain={[(min) => Math.max(0, Math.floor((min - 200) / 100) * 100), (max) => Math.ceil((max + 200) / 100) * 100]} tick={{ fill: "#A9C2B8", fontSize: 12 }} axisLine={false} tickLine={false} width={52} tickFormatter={(v) => `₹${v}`} />
              <Tooltip
                contentStyle={{ background: "#0c241e", border: "1px solid rgba(110,231,197,0.2)", borderRadius: 12, color: "#EEF3EA" }}
                formatter={(v, k) => [`₹${Number(v).toLocaleString("en-IN")}`, names[k] ?? k]}
              />
              <Legend formatter={(k) => <span style={{ color: "#EEF3EA", fontSize: 12 }}>{names[k] ?? k}</span>} iconType="circle" iconSize={8} />
              {active.map(([k, color]) => (
                <Line key={k} type="monotone" dataKey={k} stroke={color} strokeWidth={2.5} dot={{ r: 3 }} connectNulls isAnimationActive />
              ))}
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
